import { useMutation } from "@tanstack/react-query"
import apiInputService from "services/apiInputService"
import { ResetValidationPayload } from "./@types"

const resetActivityItem = async (payload: ResetValidationPayload) => {
    const { data } = await apiInputService.post("/activityItem/reset-step/", payload);

    return data;
}

export const useResetActivityItem = (options?: any) => {
    return useMutation(resetActivityItem, {
        ...options,
    });
}